import { useCallback, useState } from 'react';
import {
  WES_DEFAULT_DIMENSIONS,
  WES_PAGE_SIZE,
  isDimensionKey,
  nextSort,
  type WesDimKey,
  type WesDisplayMode,
  type WesTableSort,
} from './wesPalletStagingTable';

// Table state is independent of filters, Staging Scope and chart configuration. It lives in the dashboard so it survives tab switches and clears when the report is left.
export function useWesLocationTable() {
  const [dimensions, setDimensionsState] = useState<WesDimKey[]>(WES_DEFAULT_DIMENSIONS);
  const [mode, setMode] = useState<WesDisplayMode>('percent');
  const [sort, setSort] = useState<WesTableSort | null>(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSizeState] = useState(WES_PAGE_SIZE);

  const setPageSize = useCallback((size: number) => {
    setPageSizeState(size);
    setPage(0);
  }, []);

  const setDimensions = useCallback((keys: WesDimKey[]) => {
    if (keys.length === 0) return;
    setDimensionsState(keys);
    setPage(0);
    // A sort on a column that is no longer visible falls back to the default order.
    setSort((prev) => (prev && isDimensionKey(prev.key) && !keys.includes(prev.key) ? null : prev));
  }, []);

  const cycleSort = useCallback((key: string) => {
    setSort((prev) => nextSort(prev, key));
    setPage(0);
  }, []);

  const resetPage = useCallback(() => setPage(0), []);

  return { dimensions, mode, sort, page, pageSize, setDimensions, setMode, cycleSort, setPage, setPageSize, resetPage };
}

export type WesLocationTableState = ReturnType<typeof useWesLocationTable>;
